/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.referencias': 'Referencias',
  'referencias.agregarReferencias': 'Crear Referencias',
  'referencias.modificarReferencias': 'Editar Referencias',
  'referencias.referenciaId': 'Referencia Id',
  'referencias.empresaId': 'Empresa Id',
  'referencias.referenciaDescripcion': 'Referencia Descripción',
  'referencias.VerReferencias': 'Ver Referencias',
};
